import React from "react";

const ProcessSection = () => {
  const steps = [
    {
      text: "We study patient journeys, care gaps, and system inefficiencies.",
      highlight: "Research",
    },
    {
      text: "We translate findings into actionable healthcare intelligence.",
      highlight: "Insights",
    },
    {
      text: "We build solutions that integrate seamlessly into care workflows.",
      highlight: "Platform",
    },
    {
      text: "We enable better engagement, improved decisions, and continuous care.",
      highlight: "Outcomes",
    },
  ];

  return (
    <section className="w-full md:py-16 px-4 md:px-0">
      <div className="mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        {/* LEFT: Timeline - Occupies 7 columns */}
        <div className="md:px-8 md:col-span-8">
          <div className="relative ">
            {/* Vertical line */}
            <div className="hidden sm:block absolute left-3 top-0 bottom-0 w-[2px] bg-[#D6DBF5]" />

            <div className="flex flex-col gap-3 md:gap-8">
              {steps.map((step, index) => (
                <div key={index} className="relative flex items-start gap-4">
                  {/* Dot */}
                  <div className="hidden sm:flex w-6 h-6 items-center justify-center">
                    <div className="w-3 h-3 rounded-full primary-bg " />
                  </div>

                  {/* Card */}
                  <div className="bg-white rounded-lg px-4 sm:px-6 py-4 w-full">
                    <p className=" text-[#5569A0] leading-relaxed">
                      {step.text}{" "}
                      <span className="font-semibold ">
                        - {step.highlight}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT: Image - Occupies 5 columns */}
        <div className="w-full flex justify-center lg:justify-end md:col-span-4">
          <img
            src="/assets/research&Innovation/ProcessSectionImg.svg"
            alt="Healthcare technology"
            className="
            w-full 
            max-w-md sm:max-w-lg lg:max-w-full 
            rounded-xl 
            object-cover
          "
          />
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
